module.exports = "<ul #sidenav id=\"slide-out\" class=\"{{ class }} side-nav\" >\r\n  <ng-content></ng-content>\r\n  <div class=\"sidenav-bg mask-strong\"></div>    \r\n</ul>\r\n<div (click)=\"hide()\" #overlay id=\"sidenav-overlay\" style=\"display: none;\"></div>"


//////////////////
// WEBPACK FOOTER
// C:/ProactiView/ProactiView-Client/src/libs/mdbootstrap/typescripts/pro/sidenav/sidenav.component.html
// module id = ../../../../../src/libs/mdbootstrap/typescripts/pro/sidenav/sidenav.component.html
// module chunks = main